module.exports = __webpack_public_path__ + "img/QuestionMark.bce1bce7.png";